import {formatPercentage} from '@/_application/core/utils/number';
import {calculateDiscountPercentage} from '@/lib/price-utils';
import cn from 'classnames';

interface DiscountSimpleProps {
    variant?: 'horizontal' | 'vertical' | 'details';
    basePrice: string;
    price: string;
}

const DiscountSimple = ({variant, basePrice, price}: Readonly<DiscountSimpleProps>) => {
    return (
        <div
            className={cn('flex items-center gap-1', {
                'min-h-[15px]': variant === 'horizontal',
            })}>
            <p
                className={cn('inline-block text-KPZ_text_2nd line-through md:text-xs', {
                    'text-xs text-white md:text-base md:text-KPZ_Gray-30': variant === 'details',
                    'text-xs': variant === 'horizontal',
                    'text-[10px]': variant === 'vertical',
                })}>
                {basePrice}
            </p>
            <p
                className={cn(
                    'percent-discount inline-flex items-center justify-center rounded-xl border border-KPZ_Cam px-2 text-[8px] font-bold text-KPZ_Cam md:text-[10px]',
                    {
                        'ml-2': variant === 'horizontal',
                        'border-white text-white md:border-KPZ_Cam md:text-KPZ_Cam': variant === 'details',
                    },
                )}>
                {formatPercentage(calculateDiscountPercentage(basePrice, price) ?? '')}
            </p>
        </div>
    );
};

export default DiscountSimple;
